<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Part-Title-1" id="_idParaDest-4"><a id="_idTextAnchor003"></a>PART ONE</p>
<p class="ORIM-Chapter-Subtitle ParaOverride-2" id="_idParaDest-5"><span class="CharOverride-5"><a id="_idTextAnchor004"></a>THE CLOAK OF NIGHT</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Rosen_BayouStrangler_4P-6.vue?0591ddc7